import { reducerWithInitialState } from 'typescript-fsa-reducers'
import * as actions from '../../actions/contacts'

export interface Contact {
	id: string
	questionType: string
	companyName: string
	staffName: string
	email: string
	telephone: string
	createdAt: number
}

export interface ContactsState {
	isCreating: boolean
	createSuccess: boolean
	createFailed: boolean
}

const initialState: ContactsState = {
	isCreating: false,
	createSuccess: false,
	createFailed: false
}

export const contactsReducer = reducerWithInitialState(initialState)
.case(actions.createClipAsyncAction.start, (state, contactCreateForm) => {
	return Object.assign({}, state, {
		contactCreateForm,
		isCreating: true,
		createSuccess: false,
		createFailed: false
	})
})
.case(actions.createClipAsyncAction.done, (state, payload) => {
	return Object.assign({}, state, {
		isCreating: false,
		createSuccess: true
	})
})
.case(actions.createClipAsyncAction.failure, (state, payload) => {
	return Object.assign({}, state, {
		isCreating: false,
		createFailed: true
	})
})


// WEBPACK FOOTER //
// ./src/states/contacts/index.ts